module.exports = __webpack_public_path__ + "img/icon_insure.7204ece1.svg";